import React from 'react';

import {OutlinedTextFieldProps, TextField as MuiTextField} from '@mui/material';
import {readOnlyContext} from 'common/context/ReadOnlyContext';

type Props = Partial<OutlinedTextFieldProps> & {
   variant?: 'outlined';
};
const TextField = (props: Props) => {
   const {variant = 'outlined', placeholder, disabled, ...otherProps} = props;
   const readOnly = React.useContext(readOnlyContext);
   const label = placeholder;

   return (
      <MuiTextField
         label={label}
         variant={variant}
         fullWidth
         disabled={disabled || readOnly}
         {...otherProps}
      />
   );
};

export default React.memo(TextField);
